import styles from './InputArrayFlex.sass'

const fieldOf = input => {
  const name = input.props.name || ''

  return name.split('.').pop()
}

// Replaces rhfa's InputArrayTable: same items, but flex rows instead
// of table cells. Cells shrink to their content and, when the
// container gets phone-narrow, the ingredient search drops to its
// own full-width line (see the container query in the sass file).
export const InputArrayFlex = ({ items }) =>
  <div className={styles.root}>
    {items.map(({ idx, closeButton, inputs }) =>
      <div className={styles.row} key={idx}>
        <div className={styles.close}>
          {closeButton}
        </div>
        {inputs && inputs.map(input =>
          <div
            className={styles.cell}
            data-field={fieldOf(input)}
            key={input.props.name}
          >
            {input}
          </div>
        )}
      </div>
    )}
  </div>
